import { useEffect, useState } from 'react';
const useShadowOnScroll = () => {
    const [isShowHeaderShadow, setIsShowHeaderShow] = useState(false);
    const [body, setBody] = useState();
    const handleScroll = () => {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        setIsShowHeaderShow(body.scrollTop > 0);
    };
    useEffect(() => {
        if (body) {
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            body.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (body) {
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                body.removeEventListener('scroll', handleScroll);
            }
        };
    }, [body]);
    return { isShowHeaderShadow, setBody };
};
export default useShadowOnScroll;
